// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"GSTDetailsFormGroupHeader_Wrapper__cS49b","checkBox":"GSTDetailsFormGroupHeader_checkBox__2noff","TitleText":"GSTDetailsFormGroupHeader_TitleText__1Hg8-"};